import { ADMIN_USER_LEVEL } from '@/shared/common/constants/userLevels.constant';

/**
 * Niveles con acceso de lectura a la gestión de cuentas adicionales — criterio
 * técnico de ML-5: "Tabla visible para niveles 2, 3 y 4". El nivel 1 (usuario
 * básico) y el 5 (`EXTERNAL_USER_LEVEL`, externo con tarjeta) quedan afuera.
 *
 * Tipado como `readonly number[]` y no como tupla literal a propósito: los
 * consumidores comparan contra `accountStore.getLevel`, que es `number`.
 */
export const ADDITIONAL_ACCOUNTS_VIEW_USER_LEVELS: readonly number[] = [2, 3, ADMIN_USER_LEVEL];
